// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"e89950bc","815":"e2a17a4b","827":"e2a17a4b"}[chunkId] + ".chunk.css";
};